<template>
  <span>
    <v-icon
      :x-small="small"
      v-for="i in stars"
      :key="i"
      :color="'#fff'"
    >
    {{ icons.star }}
  </v-icon>
  <v-icon
    v-if="isSuperior"
    :x-small="small"
    :color="'#fff'"
  >
    {{ icons.superior }}
  </v-icon>
  </span>
</template>

<script>
  import { mdiPlusThick, mdiStar } from '@mdi/js'

  export default {
    name: 'HotelStars',

    props: {
      poi: {
        required: true,
        type: Object,
      },

      small: {
        default: false,
        type: Boolean,
      },
    },

    data() {
      return {
        icons: {
          star: mdiStar,
          superior: mdiPlusThick,
        },
      }
    },

    computed: {
      stars() {
        if (this.poi.venue_finder_sub_category !== 'hotel') return [];

        let stars = this.poi.venue.hotel_stars;

        if (! stars) return [];

        stars = parseInt(stars.replace(/[^0-9]/ig, ""))

        if (isFinite(stars)) {
          return new Array(stars)
        }

        return [];
      },

      isSuperior() {
        return false;
      },
    }
  }
</script>

<style lang="sass" scoped>
  ::v-deep .v-icon
    margin-bottom: 10px
</style>
